// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 496 ? "graphql-print" : chunkId) + "." + {"291":"a292904df71cbef8","496":"83edc8afc0370428","640":"2a1316fa6141b928","723":"04948072a87bd1d5"}[chunkId] + ".js";
};